var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66646 14C8.47709 14 8.29282 13.9454 8.14133 13.8444L4.64047 11.4722C4.53338 11.399 4.44683 11.3047 4.38761 11.1967C4.32839 11.0888 4.29811 10.9701 4.29913 10.85V8.30667L0.0980962 1.13556C0.0289098 1.01688 -0.0046936 0.884357 0.000527608 0.750778C0.00574882 0.617198 0.0496183 0.487069 0.127904 0.372942C0.20619 0.258815 0.316251 0.164542 0.447469 0.0992185C0.578687 0.0338944 0.726634 -0.000276621 0.877038 1.6865e-06H13.1301C13.2819 2.5228e-05 13.4312 0.0351754 13.5632 0.101996C13.6952 0.168817 13.8053 0.265008 13.8827 0.381113C13.9596 0.49935 14 0.633473 14 0.770001C14 0.90653 13.9596 1.04065 13.8827 1.15889L9.50666 8.32222V13.2222C9.5078 13.3672 9.46333 13.5095 9.37828 13.6332C9.29322 13.7569 9.17096 13.857 9.0253 13.9222C8.91327 13.9705 8.79093 13.9971 8.66646 14Z",
    fill: "#6A6A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.c4e3789feb2ada4a25833ec2149d187f.svg";
export { ForwardRef as ReactComponent };